import { AssignmentStatus } from '@/types';

export const getProgressPercentage = (status: AssignmentStatus): number => {
  const statusOrder: AssignmentStatus[] = [
    'created',
    'briefing_prepared',
    'interview_scheduled',
    'interview_in_progress',
    'interview_completed',
    'transcript_ready',
    'draft_generated',
    'under_review',
    'approved',
    'published',
  ];
  const index = statusOrder.indexOf(status);
  return index >= 0 ? ((index + 1) / statusOrder.length) * 100 : 0;
};
